import { createSlice, type PayloadAction } from "@reduxjs/toolkit/react";
import {
  ChatMessageSource,
  type ChatMessageSource as ChatMessageSourceValue,
} from "../utilities/chat";

export type InitialQuestion = {
  text: string;
  source: ChatMessageSourceValue;
};

type ChatState = {
  isOpen: boolean;
  initialQuestion: InitialQuestion | null;
};

const initialState: ChatState = {
  isOpen: false,
  initialQuestion: null,
};

export const chat = createSlice({
  name: "chat",
  initialState,
  reducers: {
    open: (state): ChatState => ({ ...state, isOpen: true }),
    close: (state): ChatState => ({ ...state, isOpen: false }),
    openWithQuestion: (_state, action: PayloadAction<string>): ChatState => ({
      isOpen: true,
      initialQuestion: {
        text: action.payload,
        source: ChatMessageSource.Typed,
      },
    }),
    openWithSuggestion: (_state, action: PayloadAction<string>): ChatState => ({
      isOpen: true,
      initialQuestion: {
        text: action.payload,
        source: ChatMessageSource.Suggestion,
      },
    }),
    clearInitialQuestion: (state): ChatState => ({
      ...state,
      initialQuestion: null,
    }),
  },
});
